import type { ReactElement } from 'react';
import { UserRole } from '@/types/auth';
import HomePage from '@/pages/Home';
import CourseModulesPage from '@/pages/CourseModules/Page';
import LessonsPage from '@/pages/Lessons/Page';
import TestsPage from '@/pages/Tests/Page';
import ExamsPage from '@/pages/Exams/Page';
import CourseSkillsPage from '@/pages/CourseSkills/Page';
import CourseTechnologiesPage from '@/pages/CourseTechnologies/Page';
import CourseProjectsPage from '@/pages/CourseProjects/Page';
import CoursePartnersPage from '@/pages/CoursePartners/Page';
import BadgesPage from '@/pages/Badges/Page';
import CertificatesPage from '@/pages/Certificates/Page';
import MentorsPage from '@/pages/Mentors/Page';
import PartnersPage from '@/pages/Partners/Page';
import GraduatesPage from '@/pages/Graduates/Page';
import PresalesPage from '@/pages/Presales/Page';
import PromocodesPage from '@/pages/Promocodes/Page';
import SubscriptionPlansPage from '@/pages/SubscriptionPlans/Page';
import NotificationsPage from '@/pages/Notifications/Page';

export interface AdminRoute {
  path: string;
  element: ReactElement;
}

export const routePermissions: Record<string, readonly UserRole[]> = {
  '/': [UserRole.SUPER_ADMIN, UserRole.STATISTICS_ADMIN, UserRole.COURSE_ADMIN, UserRole.SHOP_ADMIN, UserRole.NOTIFICATION_ADMIN],
  '/course-modules': [UserRole.SUPER_ADMIN, UserRole.COURSE_ADMIN],
  '/lessons': [UserRole.SUPER_ADMIN, UserRole.COURSE_ADMIN],
  '/tests': [UserRole.SUPER_ADMIN, UserRole.COURSE_ADMIN],
  '/exams': [UserRole.SUPER_ADMIN, UserRole.COURSE_ADMIN],
  '/course-skills': [UserRole.SUPER_ADMIN, UserRole.COURSE_ADMIN],
  '/course-technologies': [UserRole.SUPER_ADMIN, UserRole.COURSE_ADMIN],
  '/course-projects': [UserRole.SUPER_ADMIN, UserRole.COURSE_ADMIN],
  '/course-partners': [UserRole.SUPER_ADMIN, UserRole.COURSE_ADMIN],
  '/badges': [UserRole.SUPER_ADMIN, UserRole.COURSE_ADMIN],
  '/certificates': [UserRole.SUPER_ADMIN, UserRole.COURSE_ADMIN],
  '/mentors': [UserRole.SUPER_ADMIN, UserRole.COURSE_ADMIN],
  '/partners': [UserRole.SUPER_ADMIN, UserRole.COURSE_ADMIN],
  '/graduates': [UserRole.SUPER_ADMIN, UserRole.COURSE_ADMIN],
  '/presales': [UserRole.SUPER_ADMIN, UserRole.COURSE_ADMIN],
  '/promocodes': [UserRole.SUPER_ADMIN, UserRole.COURSE_ADMIN, UserRole.SHOP_ADMIN],
  '/subscription-plans': [UserRole.SUPER_ADMIN, UserRole.COURSE_ADMIN],
  '/notifications': [UserRole.SUPER_ADMIN, UserRole.NOTIFICATION_ADMIN],
};

export const appRoutes: AdminRoute[] = [
  { path: '/', element: <HomePage /> },
  { path: '/course-modules', element: <CourseModulesPage /> },
  { path: '/lessons', element: <LessonsPage /> },
  { path: '/tests', element: <TestsPage /> },
  { path: '/exams', element: <ExamsPage /> },
  { path: '/course-skills', element: <CourseSkillsPage /> },
  { path: '/course-technologies', element: <CourseTechnologiesPage /> },
  { path: '/course-projects', element: <CourseProjectsPage /> },
  { path: '/course-partners', element: <CoursePartnersPage /> },
  { path: '/badges', element: <BadgesPage /> },
  { path: '/certificates', element: <CertificatesPage /> },
  { path: '/mentors', element: <MentorsPage /> },
  { path: '/partners', element: <PartnersPage /> },
  { path: '/graduates', element: <GraduatesPage /> },
  { path: '/presales', element: <PresalesPage /> },
  { path: '/promocodes', element: <PromocodesPage /> },
  { path: '/subscription-plans', element: <SubscriptionPlansPage /> },
  { path: '/notifications', element: <NotificationsPage /> },
];